import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import {
  toWidget,
  toWidgetEditable,
} from "@ckeditor/ckeditor5-widget/src/utils"
import { enablePlaceholder } from "@ckeditor/ckeditor5-engine/src/view/placeholder"
import Widget from "@ckeditor/ckeditor5-widget/src/widget"
import InsertRecommendBox from "./insertRecomendBox"

export default class RecommendBoxEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.defineSchema()
    this.defineConvrters()
    this.editor.commands.add(
      "insertRecommendBox",
      new InsertRecommendBox(this.editor)
    )
  }

  defineSchema() {
    const schema = this.editor.model.schema

    schema.register("recommendBox", {
      isObject: true,
      allowWhere: "$block",
    })
    schema.register("recommendBoxLabel", {
      allowIn: "recommendBox",
      allowContentOf: "$block",
    })
    schema.register("recommendBoxErrorLabel", {
      allowIn: "recommendBox",
      allowContentOf: "$block",
    })
    schema.register("recommendBoxISBN", {
      isLimit: true,
      allowIn: "recommendBox",
      allowContentOf: "$block",
    })
  }

  defineConvrters() {
    const conversion = this.editor.conversion

    // <recommendBox> converters
    conversion.for("upcast").elementToElement({
      model: "recommendBox",
      view: {
        name: "div",
        classes: "recommend-box",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "recommendBox",
      view: {
        name: "div",
        classes: "recommend-box",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "recommendBox",
      view: (modelElement, viewWriter) => {
        const section = viewWriter.createContainerElement("div", {
          class: "recommend-box",
        })

        return toWidget(section, viewWriter, { label: "recommend box widget" })
      },
    })

    // <recomendBoxLabel> converters
    conversion.elementToElement({
      model: "recommendBoxLabel",
      view: {
        name: "label",
        classes: ["recommend-box-label", "recommend-box-children"],
      },
    })

    // <recomendBoxErrorLabel> converters
    conversion.for("upcast").elementToElement({
      model: "recommendBoxErrorLabel",
      view: {
        name: "label",
        classes: [
          "recommend-box-error-label",
          "recommend-box-error-label-disable",
          "recommend-box-children",
        ],
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "recommendBoxErrorLabel",
      view: {
        name: "label",
        classes: [
          "recommend-box-error-label",
          "recommend-box-error-label-disable",
          "recommend-box-children",
        ],
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "recommendBoxErrorLabel",
      view: (modelElement, viewWriter) => {
        const view = viewWriter.createContainerElement("label", {
          class:
            "recommend-box-error-label recommend-box-error-label-disable recommend-box-children",
        })

        // recommendBoxISBNモデルから飛んできたイベントを受けてエラーメッセージ用のラベルの制御をclassで行う
        this.on("enableRecomendBoxErrorLabel", (evt, labelElement) => {
          viewWriter.removeClass(
            "recommend-box-error-label-disable",
            labelElement
          )
        })
        this.on("disableRecommendBoxErrorLabel", (evt, labelElement) => {
          viewWriter.addClass("recommend-box-error-label-disable", labelElement)
        })
        return toWidget(view, viewWriter)
      },
    })

    // <recommendBoxISBN> converters
    conversion.for("upcast").elementToElement({
      model: "recommendBoxISBN",
      view: {
        name: "h3",
        classes: ["recommend-box-isbn", "recommend-box-children"],
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "recommendBoxISBN",
      view: {
        name: "h3",
        classes: ["recommend-box-isbn", "recommend-box-children"],
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "recommendBoxISBN",
      view: (modelElement, viewWriter) => {
        const view = viewWriter.createEditableElement("h3", {
          class: "recommend-box-isbn recommend-box-children",
        })
        enablePlaceholder({
          view: this.editor.editing.view,
          element: view,
          text: "例: 9780123456789, 098765432X",
        })
        view.on("change:isFocused", (evt, property, is) => {
          if (!is) {
            if (evt.source._children.length == 0) {
              return
            } else if (evt.source._children.length > 0) {
              const isbn = evt.source._children.reduce((acc, element) => {
                if (element.is("span") && element._children[0].is("text")) {
                  return acc + element._children[0].data.trim()
                } else if (element.is("text")) {
                  return acc + element.data.trim()
                } else {
                  return acc
                }
              }, "")
              if (isbn) {
                const recommendBoxErrorLabelElement = view.parent._children[1]
                // isbnのバリデーションの成否によってエラーメッセージ用ラベルの制御を実施するためのイベントをへ飛ばす
                // このイベントはrecommendBoxErrorLabel側で受けとることを想定
                if (!this.checkIsbn(isbn)) {
                  this.fire(
                    "enableRecomendBoxErrorLabel",
                    recommendBoxErrorLabelElement
                  )
                } else {
                  this.fire(
                    "disableRecommendBoxErrorLabel",
                    recommendBoxErrorLabelElement
                  )
                }
              }
            }
          }
        })
        return toWidgetEditable(view, viewWriter)
      },
    })
  }
  checkIsbn(isbn) {
    if (isbn.match(/^\d{9}[\dX]$/)) {
      return true
    } else if (isbn.match(/^(978|979)\d{10}$/)) {
      return true
    } else {
      return false
    }
  }
}
